import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.jsx";
import { InitialDataContext } from "./context/InitialDataContext.js";

const container = document.getElementById("root");
const initialData = typeof window !== "undefined" ? window.__INITIAL_DATA__ : null;

if (container) {
  createRoot(container).render(
    <StrictMode>
      <HelmetProvider>
        <InitialDataContext.Provider value={initialData}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </InitialDataContext.Provider>
      </HelmetProvider>
    </StrictMode>
  );
}